var map = {
	"./apple.svg": 9089,
	"./arrow.svg": 9338,
	"./cucumber.svg": 7939,
	"./flask.svg": 4388,
	"./lavender.svg": 9730,
	"./lemon.svg": 3075,
	"./orange.svg": 1925,
	"./passionfruit.svg": 2296,
	"./rose.svg": 8539,
	"./rosemary.svg": 1394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3843;